import {
	browserBootstrapFromGlobal,
	connectEmulators,
	initFirebaseClient,
} from "@momo/firebase-client";

// The one Firebase app, with App Check: staff sign in through Revent's sendOTP
// and verifyOTP, which enforce it outside the emulator; Revia's own callables
// do not read it. Against the emulator initFirebaseClient skips App Check and
// keeps its own path (long-polling included).
const client = initFirebaseClient(browserBootstrapFromGlobal(), {
	emulator: import.meta.env.DEV,
});
export const emulatorEndpoints = import.meta.env.DEV
	? connectEmulators(client)
	: undefined;
export const { app, auth, db, functions } = client;
